module.exports = __webpack_public_path__ + "img/retro_mobile.d2a210d7.jpg";